/** 配置接口无 archTypes 时的本地兜底 */
export const DEFAULT_ARCH_OPTIONS = ['AMD64', 'ARM64', 'x86_64'];

function hasMeaningfulArchTypes(archTypes?: string[] | null): boolean {
  if (!Array.isArray(archTypes)) return false;
  return archTypes.some((item) => String(item ?? '').trim());
}

/**
 * 按优先级取首个非空 archTypes（空数组不算已配置）。
 */
export function pickConfiguredArchTypes(...candidates: (string[] | null | undefined)[]): string[] | undefined {
  for (const list of candidates) {
    if (hasMeaningfulArchTypes(list)) return list as string[];
  }
  return undefined;
}

/**
 * 解析架构选项：配置接口 archTypes 非空则用其值，否则本地兜底。
 */
export function resolveArchOptions(archTypes?: string[] | null): string[] {
  if (!hasMeaningfulArchTypes(archTypes)) return [...DEFAULT_ARCH_OPTIONS];
  return (archTypes as string[]).map((item) => String(item ?? '').trim()).filter(Boolean);
}
